/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Wide_Bat_DineInputs */

const en_neat_wide_bat_dine = /** @type {(inputs: Neat_Wide_Bat_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

const de_neat_wide_bat_dine = /** @type {(inputs: Neat_Wide_Bat_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Neat_Wide_Bat_DineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_wide_bat_dine = /** @type {((inputs?: Neat_Wide_Bat_DineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Wide_Bat_DineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_wide_bat_dine(inputs)
	return de_neat_wide_bat_dine(inputs)
});